import { render, staticRenderFns } from "./newRightArrow.vue?vue&type=template&id=272afd24"
import script from "./newRightArrow.vue?vue&type=script&lang=js"
export * from "./newRightArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports